// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSessionRevokeBody = {
  doRevokeAllSessions: boolean;
};

export type typeSessionRevokeOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { revokedCount: number };
};

export type typeSessionRevokeOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRevokeOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRevokeOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSessionRevokeBody = {
  type: "object",
  properties: { doRevokeAllSessions: { type: "boolean" } },
  required: ["doRevokeAllSessions"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSessionRevoke(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSessionRevokeBody);
  }

  return async function postSessionRevoke(
    payload: typeSessionRevokeBody,
  ): Promise<typeSessionRevokeOutput200 | typeSessionRevokeOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSessionRevoke" failed before calling the network. #ab3c5125cff8`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ab3c5125cff8" },
        },
        data: null,
      } as typeSessionRevokeOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/session/revoke`,
      httpMethod: "POST",
      options,
    })) as typeSessionRevokeOutput200 | typeSessionRevokeOutput400;
  };
}
